<template>
  <div class="login row">
    <div class="col-lg-5 offset-lg-3 col-md-8 offset-md-2 col-sm-12">
      <div class="card border border-secondary">
        <div class="card-header bg-secondary">
          <h5 class="mb-0 text-white">Login</h5>
        </div>
        <div class="card-body pb-0">
          <form v-on:keyup.enter="validateLogin">
            <div class="input-group mb-3">
              <span class="input-group-text strong" style="width: 100px"
                >E-mail:</span
              >
              <input
                type="text"
                class="form-control"
                placeholder="lavagem"
                v-model="email"
                v-on:keyup="validateForm"
              />
              <span class="input-group-text d-none d-md-block"
                >@ccleanman.com.br</span
              >
            </div>
            <div class="input-group mb-3">
              <span
                class="input-group-text strong"
                id="basic-addon2"
                style="width: 100px"
                >Senha:</span
              >
              <input
                :type="pswdType"
                class="form-control"
                placeholder="******"
                v-model="password"
                v-on:keyup="validateForm"
                autocomplete="on"
              />
              <span
                class="input-group-text cursor-pointer"
                v-on:click="changeVisibility"
              >
                <i class="material-icons">{{ eyeIcon }}</i>
              </span>
            </div>
          </form>
        </div>
        <div class="card-footer text-center">
          <button
            class="btn btn-success btn-lg"
            style="min-width: 200px"
            v-on:click="validateLogin"
            disabled
            v-if="loading"
          >
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Carregando...</span>
            </div>
          </button>
          <button
            class="btn btn-success btn-lg"
            style="min-width: 200px"
            v-on:click="validateLogin"
            :disabled="btnDisabled"
            v-else
          >
            Acessar
            <i
              class="material-icons inline-icon"
              style="font-size: 28px !important"
              >login</i
            >
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Helper from "@/components/Helper.vue";
import Swal from "sweetalert2";
//import * as $ from "jquery"
import axios from "axios";
import { cryptString } from "@/utils/crypt";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      btnDisabled: false,
      eyeIcon: "visibility_off",
      pswdType: "password",
      loading: false,
    };
  },
  beforeMount() {
    this.getStatusList();
  },
  mounted() {
    //console.log("Login")
    $("#navbar-links").hide();
    $("#navbar-links-logout").hide();

    if (sessionStorage.getItem("forceRefresh") === "1") {
      sessionStorage.removeItem("forceRefresh");
      location.reload();
    }
  },
  methods: {
    getStatusList() {
      if (sessionStorage.getItem("statusList") == null) {
        // get data
        axios.get(Helper.api + "/lookup/car-clean-status").then((response) => {
          delete response.data.Cancelado;

          this.statusList = response.data;
          sessionStorage.setItem("statusList", JSON.stringify(response.data));
        });
      } else {
        this.statusList = JSON.parse(sessionStorage.getItem("statusList"));
      }
    },
    validateLogin() {
      this.loading = true;
      let emailSend = this.email;
      if (this.email.indexOf("@") < 0) {
        emailSend = this.email + "@ccleanman.com.br";
      }

      this.eyeIcon = "visibility";
      this.pswdType = "password";

      let body = {
        email: emailSend,
        password: this.password,
      };

      Helper.axiosRequest({
        url: "/login",
        body: body,
        method: "post",
        onFail: (err) => {
          console.log(err);
          let msg = "Erro ao efetuar login";

          if (err.response.data.message) {
            msg = err.response.data.message;
          }

          Swal.fire({
            icon: "error",
            title: "Erro ao efetuar login",
            html: msg,
          });
          this.loading = false;
        },
        onSuccess: (res) => {
          this.loading = false;
          sessionStorage.setItem("jwt", res.data.access_token);
          sessionStorage.setItem("user", JSON.stringify(res.data.user));

          document.cookie = cryptString(`jwt=${res.data.access_token}`)

          let navLinks = $("#navbar-links");

          $(navLinks).show();
          $("#navbar-links-logout").show();

          Helper.checkPermissions();

          if (res.data.user.profile.toLowerCase() === "operacional") {
            this.$router.push("/lista-os");
          } else if (
            res.data.user.profile.toLowerCase() === "monitor" &&
            res.data.user.readonly === false
          ) {
            this.$router.push("/nova-os");
          } else {
            this.$router.push("/monitor");
          }
        },
      });
    },
    validateForm() {
      this.email = this.email.toLocaleLowerCase();
      if (this.email.length > 0 && this.password.length > 5) {
        this.btnDisabled = false;
      }
    },
    changeVisibility() {
      if (this.eyeIcon === "visibility_off") {
        this.eyeIcon = "visibility";
        this.pswdType = "text";
      } else {
        this.eyeIcon = "visibility_off";
        this.pswdType = "password";
      }
    },
  },
};
</script>
